import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { globalStyles } from '../global-styles.js'

@customElement('pp-loading-spinner')
export class PpLoadingSpinner extends LitElement {
  static styles = [
    globalStyles,
    css`
      :host {
        display: block;
      }

      .loading-container {
        display: flex;
        height: 100%;
        left: 0;
        padding: 0 16px;
        pointer-events: none;
        position: fixed;
        right: 0;
        top: 0;
        z-index: 99999;
        background-color: #ffffff;
        align-items: center;
        flex-direction: column;
        justify-content: center;
      }

      .pp-loading-spinner  {
        animation: spin 1.5s linear infinite;
        border-width: 3px;
        border-radius: 50%;
        border-top-color: transparent;
        height: 28px;
        width: 28px;
        border-color: transparent rgb(31, 160, 232) rgb(31, 160, 232);
      }

      @keyframes spin {
        0% {
          -webkit-transform: rotate(0deg);
          transform: rotate(0deg);
        }
        100% {
          -webkit-transform: rotate(1turn);
          transform: rotate(1turn);
        }
      }
    `
  ];

  render() {
    return html`
      <div class="loading-container">
        <div class="pp-loading-spinner"></div>
        <slot></slot>
      </div>
    `;
  }
}
